// The class picker is a button plus a list of buttons rather than a <select>, because an <option> takes
// neither a pseudo-element nor an icon font: the class artwork could never appear in the open list. What a
// select gave for free is rebuilt here - opening, picking, closing on an outside click or Escape - and the
// value rides in a hidden field so the form still posts what it always did.
function InitRoleSelects(): void {
    const wraps = document.getElementsByClassName("role-select-wrap");
    for (let i = 0; i < wraps.length; i++) {
        PaintRoleSelect(wraps[i] as HTMLElement);
    }

    document.addEventListener("click", event => {
        const target = event.target as HTMLElement | null;
        if (target !== null && target.closest(".role-select-wrap") !== null) {
            return;
        }

        CloseRoleSelects();
    });

    document.addEventListener("keydown", event => {
        if (event.key === "Escape") {
            CloseRoleSelects();
        }
    });
}

function ToggleRoleSelect(button: HTMLElement): void {
    const wrap = button.parentElement as HTMLElement;
    const wasOpen = wrap.classList.contains("role-select-wrap--open");
    CloseRoleSelects();

    if (wasOpen) {
        return;
    }

    wrap.classList.add("role-select-wrap--open");
    button.setAttribute("aria-expanded", "true");
}

function CloseRoleSelects(): void {
    const wraps = document.getElementsByClassName("role-select-wrap");
    for (let i = 0; i < wraps.length; i++) {
        wraps[i].classList.remove("role-select-wrap--open");

        const button = wraps[i].querySelector(".role-select");
        if (button !== null) {
            button.setAttribute("aria-expanded", "false");
        }
    }
}

// The four lists are alternatives, and the form posts all four fields with the server taking the first one
// that is filled. So picking in one has to clear the rest, or a leftover pick higher up the page wins over
// the one you just made.
function PickRole(option: HTMLElement): void {
    const wraps = document.getElementsByClassName("role-select-wrap");
    for (let i = 0; i < wraps.length; i++) {
        const wrap = wraps[i] as HTMLElement;
        SelectRoleOption(wrap, wrap.contains(option) ? option : null);
    }

    CloseRoleSelects();
}

function SelectRoleOption(wrap: HTMLElement, option: HTMLElement | null): void {
    const options = wrap.getElementsByClassName("role-select__option");
    for (let i = 0; i < options.length; i++) {
        options[i].classList.remove("role-select__option--selected");
    }

    if (option !== null) {
        option.classList.add("role-select__option--selected");
    }

    PaintRoleSelect(wrap);
}

// The colours of a class live on its own option, so painting the closed control is a matter of copying the
// pair off whatever is picked. Nothing picked falls back to the placeholder, which carries the plain white
// pair rather than leaving the control in the colours of a class nobody is on any more.
function PaintRoleSelect(wrap: HTMLElement): void {
    let selected = wrap.querySelector<HTMLElement>(".role-select__option--selected");
    if (selected === null) {
        selected = wrap.querySelector<HTMLElement>(".role-select__option--placeholder");
    }

    if (selected === null) {
        return;
    }

    const button = wrap.querySelector<HTMLElement>(".role-select") as HTMLElement;
    button.style.setProperty("--role-primary", selected.style.getPropertyValue("--role-primary"));
    button.style.setProperty("--role-secondary", selected.style.getPropertyValue("--role-secondary"));

    const label = wrap.querySelector<HTMLElement>(".role-select__label") as HTMLElement;
    const optionLabel = selected.querySelector<HTMLElement>(".role-select__option-label") as HTMLElement;
    label.innerText = optionLabel.innerText;

    const input = wrap.querySelector<HTMLInputElement>("input[name='roleAsString']") as HTMLInputElement;
    const value = selected.dataset.value;
    input.value = value === undefined ? "" : value;

    const icon = wrap.querySelector<HTMLElement>(".role-select__icon") as HTMLElement;
    const optionIcon = selected.querySelector<HTMLElement>(".role-icon") as HTMLElement;
    const role = optionIcon.dataset.role;
    if (role === undefined || role === "") {
        delete icon.dataset.role;
    } else {
        icon.dataset.role = role;
    }
}
